/** Three-way tool-card chrome keyed off session viewMode. */

export function getViewModeChrome(viewMode?: string) {
  const isSignal = viewMode === "signal";
  const isAlert = viewMode === "alert";

  // Default (research / chat) chrome is emerald-on-near-black to match the rest
  // of the product. NO gray/slate surfaces. Signal = emerald, Alert = sky.
  return {
    isSignal,
    isAlert,
    card: isSignal
      ? "border-emerald-300/25 bg-emerald-300/[0.03]"
      : isAlert
        ? "border-sky-300/25 bg-sky-300/[0.03]"
        : "border-emerald-400/20 bg-[#0b0d10]",
    icon: isSignal ? "text-emerald-100" : isAlert ? "text-sky-100" : "text-emerald-200",
    iconMuted: isSignal
      ? "text-emerald-100/90"
      : isAlert
        ? "text-sky-100/90"
        : "text-emerald-200/90",
    text: isSignal ? "text-emerald-50" : isAlert ? "text-sky-50" : "text-white",
    subtext: isSignal ? "text-emerald-50/80" : isAlert ? "text-sky-50/80" : "text-white/75",
    divider: isSignal
      ? "border-emerald-300/25"
      : isAlert
        ? "border-sky-300/25"
        : "border-white/[0.08]",
    button: isSignal
      ? "bg-emerald-200 hover:bg-emerald-100 text-emerald-950"
      : isAlert
        ? "bg-sky-200 hover:bg-sky-100 text-sky-950"
        : "bg-emerald-500 hover:bg-emerald-400 text-emerald-950",
    focusRing: isSignal
      ? "focus-visible:ring-emerald-300/60"
      : isAlert
        ? "focus-visible:ring-sky-300/60"
        : "focus-visible:ring-emerald-400/60",
    optionBtn: isSignal
      ? "border border-emerald-300/30 bg-emerald-300/7 text-emerald-100 hover:bg-emerald-300/12 hover:border-emerald-200/45"
      : isAlert
        ? "border border-sky-300/30 bg-sky-300/7 text-sky-100 hover:bg-sky-300/12 hover:border-sky-200/45"
        : "border border-white/[0.10] bg-white/[0.03] text-white hover:bg-white/[0.06] hover:border-emerald-400/40",
    inputFocus: isSignal
      ? "focus:border-emerald-300/50"
      : isAlert
        ? "focus:border-sky-300/50"
        : "focus:border-emerald-400/50",
    sendBtn: isSignal
      ? "bg-emerald-200 hover:bg-emerald-100"
      : isAlert
        ? "bg-sky-200 hover:bg-sky-100"
        : "bg-emerald-500 hover:bg-emerald-400",
    streamingBorder: isSignal
      ? "border-emerald-300/25"
      : isAlert
        ? "border-sky-300/25"
        : "border-emerald-400/25",
  };
}
